import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { Modal, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

import BrandContext from '../../contexts/BrandContext'
import EventInformation from '../atoms/EventInformation'
import SVGMoon from '../atoms/SVGMoon_chessGrottoHack'
import SVGSun from '../atoms/SVGSun_chessGrottoHack'
import Upgrade from '../molecules/Upgrade'
import UpgradeV2 from '../molecules/UpgradeV2'
import ExtraNightsBlock from './ExtraNightsBlock'
import dateHelpers from '../../helpers/dateHelpers'

const maxFeaturedUpgrades = 4

class UpgradeList extends PureComponent {
  render () {
    const {
      childrenMaxAge,
      childrenMinAge,
      defaultComposition,
      endDate,
      extraNightButtonSmallSize,
      extraNightMessage,
      extraNights,
      featuredEventUpgradesTitle,
      handleCompositionChange,
      handleDateSelection,
      handleDaysSelection,
      handleExtraNightCTA,
      handleGroupUpgradeSelection,
      handleUpgradeCTA,
      handleUpgradeModalTrigger,
      hotelCode,
      hotelImage,
      hotelName,
      isExtraNightsVisible,
      listLayout,
      modalState,
      startDate,
      upgrades
    } = this.props

    const { brandConfig = {} } = this.context

    const enabledUpgrades = upgrades.filter(upgrade => !upgrade.isIncludedInPackage && !upgrade.isDisabled)
    const templatedUpgrades = enabledUpgrades.map(upgrade => {
      return (
        <div className='product-item' key={`upgrade${upgrade.group}`}>
          <UpgradeV2
            row
            upgrade={upgrade}
            childrenMaxAge={childrenMaxAge}
            childrenMinAge={childrenMinAge}
            handleUpgradeCTA={handleUpgradeCTA}
            modalOpen={handleUpgradeModalTrigger}
            modalClose={handleUpgradeModalTrigger}
            defaultComposition={defaultComposition}
            handleDateSelection={handleDateSelection}
            handleDaysSelection={handleDaysSelection}
            handleCompositionChange={handleCompositionChange}
            modalIsOpen={(modalState.visible === upgrade.group)}
            handleGroupUpgradeSelection={handleGroupUpgradeSelection}
            wasText={this.props.wasText}
          />
        </div>
      )
    })

    // if we have more featured upgrades than the maxFeaturedUpgrades then they need to put at the top of the standard list
    const droppedOffFeatured = enabledUpgrades.filter(upgrade => upgrade.featured).splice(maxFeaturedUpgrades)
    const standardUpgrades = droppedOffFeatured.concat(enabledUpgrades.filter(upgrade => !upgrade.featured)).map(upgrade => {
      return (
        <li className='list-group-item upgrades__upgrade' key={`upgrade${upgrade.group}`}>
          <Upgrade
            childrenMaxAge={childrenMaxAge}
            childrenMinAge={childrenMinAge}
            defaultComposition={defaultComposition}
            handleCompositionChange={handleCompositionChange}
            handleDateSelection={handleDateSelection}
            handleDaysSelection={handleDaysSelection}
            handleGroupUpgradeSelection={handleGroupUpgradeSelection}
            handleUpgradeCTA={handleUpgradeCTA}
            modalClose={handleUpgradeModalTrigger}
            modalIsOpen={(modalState.visible === upgrade.group)}
            modalOpen={handleUpgradeModalTrigger}
            row
            upgrade={upgrade}
            wasText={this.props.wasText}
          />
        </li>
      )
    })
    let featuredUpgradesTitle
    if (featuredEventUpgradesTitle) {
      featuredUpgradesTitle = <h2>{featuredEventUpgradesTitle}</h2>
    } else if (brandConfig.featuredUpgradesTitle) {
      featuredUpgradesTitle = <h2>{brandConfig.featuredUpgradesTitle}</h2>
    } else {
      featuredUpgradesTitle = <FormattedMessage id='common.recommendedForYourBreak' tagName='h2' />
    }
    const featuredUpgrades = enabledUpgrades.filter(upgrade => upgrade.featured).slice(0, maxFeaturedUpgrades).map(upgrade => {
      return (
        <li key={`upgrade${upgrade.group}`}>
          <Upgrade
            childrenMaxAge={childrenMaxAge}
            childrenMinAge={childrenMinAge}
            defaultComposition={defaultComposition}
            handleCompositionChange={handleCompositionChange}
            handleDateSelection={handleDateSelection}
            handleDaysSelection={handleDaysSelection}
            handleGroupUpgradeSelection={handleGroupUpgradeSelection}
            handleUpgradeCTA={handleUpgradeCTA}
            modalClose={handleUpgradeModalTrigger.bind(this, null)}
            modalIsOpen={(modalState.visible === upgrade.group)}
            modalOpen={handleUpgradeModalTrigger}
            row={false}
            upgrade={upgrade}
            wasText={this.props.wasText}
          />
        </li>
      )
    })
    return (
      <div className='upgrades row'>
        <div className='col-xs-12'>
          {/* @todo: Chessington Grotto Hack FP-11263. Will need to be removed after. */}
          {modalState.visible === 'forceChooseGrottoTimeSlot' &&
            <Modal show onHide={handleUpgradeModalTrigger.bind(this, null)} backdrop='static'>
              <Modal.Header closeButton>
                <Modal.Title> Pick Your Father Christmas Grotto Slot
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Your package includes a visit to see Father Christmas. Choose your timeslot now to avoid disappointment</p>
                <Row>
                  <div className='col-xs-6'>
                    <button type='button' style={{ whiteSpace: 'normal' }} className='btn btn-default col-xs-12' onClick={() => handleUpgradeModalTrigger('GROUPCHESSINGTONUPGRADEGROTTOEVENING')}>
                      <div style={{ color: '#333333' }}>
                        <SVGMoon title='Evening' uniqueID='Evening Moon Icon' />
                      </div>
                      <h4 className='text-center'>Evening</h4>
                      <small>{dateHelpers.formatStandard(startDate, true) || ''}</small>
                    </button>
                  </div>
                  <div className='col-xs-6'>
                    <button type='button' style={{ whiteSpace: 'normal' }} className='btn btn-default col-xs-12' onClick={() => handleUpgradeModalTrigger('GROUPCHESSINGTONUPGRADEGROTTOMORNING')}>
                      <div style={{ color: '#333333' }}>
                        <SVGSun title='Morning' uniqueID='Morning Sun Icon' />
                      </div>
                      <h4 className='text-center'>Morning</h4>
                      <small>{dateHelpers.formatStandard(endDate, true) || ''}</small>
                    </button>
                  </div>
                </Row>
              </Modal.Body>
            </Modal>
          }

          {listLayout && templatedUpgrades.length > 0 &&
            <div>
              <FormattedMessage id='common.addMoreFunToYourBreak' tagName='h2' />
              <div className='product-list product-list-divided product-list-secondary'>
                {templatedUpgrades}
              </div>
            </div>
          }
          {!listLayout &&
          <React.Fragment>
            {featuredUpgrades.length > 0 &&
              <div>
                {featuredUpgradesTitle}
                <ul className='featured list-unstyled'>
                  {featuredUpgrades}
                </ul>
              </div>
            }
            {standardUpgrades.length > 0 &&
              <div>
                <FormattedMessage id='common.allAvailableUpgrades' tagName='h2' />
                <ul className='list-group upgrades'>
                  {standardUpgrades}
                </ul>
              </div>
            }
          </React.Fragment>
          }
        </div>
        {isExtraNightsVisible && (extraNights.before.isAvailable || extraNights.after.isAvailable) &&
          <div className='col-xs-12'>
            {!listLayout && <FormattedMessage id='common.addExtraNight' tagName='h2' />}
            {extraNightMessage && <EventInformation content={extraNightMessage} />}
            <ExtraNightsBlock
              hotelCode={hotelCode}
              hotelImage={hotelImage}
              hotelName={hotelName}
              extraNights={extraNights}
              handleExtraNightCTA={handleExtraNightCTA}
              extraNightButtonSmallSize={extraNightButtonSmallSize}
              listLayout={listLayout}
            />
          </div>
        }
      </div>
    )
  }
}

UpgradeList.contextType = BrandContext

UpgradeList.propTypes = {
  handleUpgradeCTA: PropTypes.func.isRequired,
  handleUpgradeModalTrigger: PropTypes.func.isRequired,
  hotelCode: PropTypes.string.isRequired,
  hotelImage: PropTypes.string,
  featuredUpgradesTitle: PropTypes.string,
  hotelName: PropTypes.string.isRequired,
  isExtraNightsVisible: PropTypes.bool.isRequired,
  upgrades: PropTypes.arrayOf(PropTypes.shape({
    composition: PropTypes.shape({
      adults: PropTypes.number,
      cars: PropTypes.number,
      children: PropTypes.number
    }).isRequired,
    description: PropTypes.string,
    id: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired,
  extraNightButtonSmallSize: PropTypes.bool,
  listLayout: PropTypes.bool.isRequired,
  wasText: PropTypes.element.isRequired
}

export default UpgradeList
